import { useMutation, useQueryClient } from "@tanstack/react-query";
import { RelabelCaseService } from "src/services/relabelCases";
import { queryKeys } from "src/constants";
import { RelabelCaseStatus } from "src/types";

const useUpdateRelabelCaseStatus = (relabelCaseService: RelabelCaseService, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { mutateAsync: updateCaseStatus, isPending: isUpdating } = useMutation({
    mutationFn: ({ caseId, status }: { caseId: string; status: RelabelCaseStatus }) =>
      relabelCaseService.updateCaseStatus(caseId, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.paginatedRelabelCases() });
      queryClient.invalidateQueries({ queryKey: queryKeys.relabelCaseStats() });
      onSuccess?.();
    }
  });

  return { updateCaseStatus, isUpdating };
};

export { useUpdateRelabelCaseStatus };
